import { SET_SETTING } from "./actions";

export default function settingsReducer(
	state = {
		start_on_icon_click: true,
		timer_duration: 45,
		unblock_duration: 3,
	},
	action
) {
	switch (action.type) {
		case SET_SETTING:
			return Object.assign({}, state, action.setting);

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../shared/store/settings/reducer.js